import {Box, MenuItem, Select} from "@mui/material";
import React from "react";
import {changeLanguageHandler} from "../translation/i18n";
import UKflag from "../assets/flags/UK-flag.png";
import VIflag from "../assets/flags/VN-flag.png";

const supportedLanguages = [
  {
    language: "English",
    value: "en",
  },
  {
    language: "Vietnamese",
    value: "vi",
  },
];

function getActiveLanguage() {
  return supportedLanguages.filter((item) => {
    return (
      item.value ==
      (window.localStorage.getItem("i18nextLng")
        ? window.localStorage.getItem("i18nextLng")
        : "vi")
    );
  })[0];
}

export function LanguageButton() {

  return (
    <Box>
      <Select
        defaultValue={getActiveLanguage().value}
        onChange={event => changeLanguageHandler(event.target.value)}
        sx={{
          color: 'white',
          fontWeight: 'bold',
          boxShadow: 'none',
          '.MuiOutlinedInput-notchedOutline': {border: 0},
          '& .MuiSelect-icon': {color: 'white'},
          display: "flex",
          alignItems: "center",
        }}
      >
        <MenuItem value={"en"}>
          <img src={UKflag} alt="" style={{width: "20px", height: "15px", marginRight: "6px"}}/>
        </MenuItem>
        <MenuItem value={"vi"}>
          <img src={VIflag} alt="" style={{width: "20px", height: "15px", marginRight: "6px"}}/>
        </MenuItem>
      </Select>
    </Box>
  );
}
